import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-yes-no-dialog',
  template: `
    <div mat-dialog-content *ngIf="!data.htmlMessage">
      <p>{{data.message}}</p>
    </div>
    <div mat-dialog-content *ngIf="data.htmlMessage" [innerHTML]="data.message">
    </div>
    <div *ngIf="data.confirmRequired">
      <app-checkbox-field [fieldName]="'accept'"
                          [Group]="formGroup"
                          [fieldLabel]="data.checkBoxLabel"
                          [disabled]="false"
                          [hasFather]="false"
                          (OnChange)="checkBoxChanged()"
      ></app-checkbox-field>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">لغو</button>
      <button mat-button [mat-dialog-close]="true" [disabled]="data.confirmRequired && !formGroup.valid"
              cdkFocusInitial>
        تایید
      </button>
    </div>
  `,
  styles: [`
    .mat-dialog-container {
      direction: rtl;
    }
  `]
})
export class YesNoDialogComponent implements OnInit {
  formGroup: FormGroup = new FormGroup({
    accept: new FormControl('', [Validators.required])
  });

  ngOnInit(): void {
  }

  constructor(
    public dialogRef: MatDialogRef<YesNoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  checkBoxChanged() {
    if (!this.formGroup.controls.accept.value) {
      this.formGroup.controls.accept.patchValue('');
    }
  }
}
